import { Image } from "@aws-amplify/ui-react"
export const NotFound = () => {
    return (

        <div className="d-flex flex-column justify-content-center" style={{ backgroundColor: "white", height: 'calc(100vh - 80px)' }}>
            <div>
                <Image src="/pictures/not_found.jpg" />
            </div>
            <h3 className="mb-5">Page not found</h3>
        </div>

    )
}